import React, { Fragment } from "react";
import ConnectedTextarea from "components/ConnectedTextarea";
import ColorPicker from "components/FormerEditor/ColorPicker";
import FilePicker from "./FilePicker";
import EditorSelect from "./EditorSelect";
import { QR_CODE_STATE_KEYS, CONTACTLESS_OPTIONS } from "constants/contactless";
import ApplyToAll from "./ApplyToAll";
import { FORM_KEY } from "utils/constants/form";

const QRCodeForm = ({ colorPickerProps }) => {
  return (
    <Fragment>
      <div className="flex flex-column">
        <div className="fw6 f5">Brand</div>
        <div className="pt2 w-100">
          <FilePicker />
        </div>
      </div>
      <div className="flex flex-column pt3">
        <div className="fw6 f5">Code</div>
        <div className="flex flex-column">
          <ColorPicker
            name={QR_CODE_STATE_KEYS.DOT_OPTIONS_COLOR}
            label="Color"
            {...colorPickerProps}
            modalLabel="Dots color"
            footer={<ApplyToAll />}
          />
        </div>
        <EditorSelect
          name={QR_CODE_STATE_KEYS.DOT_OPTIONS_TYPE}
          options={CONTACTLESS_OPTIONS.DOTS_OPTIONS_TYPE}
          label="Style"
        />
      </div>
      <div className="flex flex-column pt3 mt3 bt hairline-1">
        <div className="fw6 f5">Corners</div>
        <ColorPicker
          name={QR_CODE_STATE_KEYS.CORNERS_SQUARE_OPTIONS_COLOR}
          label="Outer color"
          {...colorPickerProps}
          modalLabel="Corners outer color"
        />
        <EditorSelect
          name={QR_CODE_STATE_KEYS.CORNERS_SQUARE_OPTIONS_TYPE}
          options={CONTACTLESS_OPTIONS.CORNERS_SQUARE_OPTIONS_TYPE}
          label="Outer style"
        />
        <ColorPicker
          name={QR_CODE_STATE_KEYS.CORNERS_DOT_OPTIONS_COLOR}
          label="Inner color"
          modalLabel="Corners inner color"
          {...colorPickerProps}
        />
        <EditorSelect
          name={QR_CODE_STATE_KEYS.CORNERS_DOT_OPTIONS_TYPE}
          options={CONTACTLESS_OPTIONS.CORNERS_DOT_OPTIONS_TYPE}
          label="Inner style"
        />
      </div>
      <div className="flex flex-column mt3 bt hairline-1">
        <ColorPicker
          name={QR_CODE_STATE_KEYS.BACKGROUND_OPTIONS_COLOR}
          label="Background"
          modalLabel="Background color"
          {...colorPickerProps}
        />
        <div className="f6 pb2">Filename</div>
        <ConnectedTextarea name={`${FORM_KEY}.name`} minRows={1} />
      </div>
    </Fragment>
  );
};

export default QRCodeForm;
